export const  getLanguageId = () =>{
    const languageId = localStorage.getItem("languageId");
    return JSON.stringify(languageId)
}